import React, { useEffect } from "react";
import { connect } from "react-redux";
import actions from "../actions/actionTypes";

const GlobalDataLoader = React.memo(({ fetch }) => {
  useEffect(() => {
    fetch();
  }, [fetch]);

  return null;
});

const mapDispatchToProps = dispatch => ({
  fetch: () => dispatch({ type: actions.FETCH_APP_DATA })
});

export default connect(
  null,
  mapDispatchToProps
)(GlobalDataLoader);
